import { CompletionBehaviorTemplate } from '../completionBehaviorTemplate/completionBehaviorTemplate';

export class FlowTemplate {

  name: string | undefined;
  settings: any | undefined;
  completionBehavior: CompletionBehaviorTemplate | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.name = payload.name;
      this.settings = payload.settings;
      if (payload.completionBehavior) {
        this.completionBehavior = new CompletionBehaviorTemplate(payload.completionBehavior);
      }
    }
  }

}
